import { Database } from 'lucide-react';
import { Button } from '../ui/button';

const NoData = ({
  title,
  subTitle,
  buttonTitle,
  onButtonClick,
}: {
  title?: string;
  subTitle?: string;
  buttonTitle?: string;
  onButtonClick?: () => void;
}) => {
  return (
    <div className="p-6">
      <div className="relative mx-auto w-24 h-24 mb-8 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full opacity-20"></div>
        <div className="relative z-10 rounded-full p-4 shadow-lg bg-muted-foreground text-fororeground">
          <Database className={`w-8 h-8 transition-all duration-300 `} />
        </div>
      </div>

      <div className="text-center space-y-2">
        <h4 className="text-muted-foreground">{title || 'No Data'}</h4>
        <p className="text-muted-foreground text-sm">
          {subTitle || 'No data found.'}
        </p>
      </div>

      {buttonTitle && onButtonClick && (
        <div className="flex items-center justify-center mt-6">
          <Button onClick={onButtonClick}>{buttonTitle}</Button>
        </div>
      )}
    </div>
  );
};

export default NoData;
